var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import gsap, { Power2 } from 'gsap';
var ContentInformation = function (_a) {
    var mainContent = _a.mainContent, _b = _a.isItemActiveFromMobile, isItemActiveFromMobile = _b === void 0 ? false : _b;
    var imageObject = isItemActiveFromMobile
        ? mainContent.responsiveImage
        : mainContent.image;
    var contentRef = useRef(null);
    var isMobileViewport = window.visualViewport.width < 1024;
    useEffect(function () {
        if (!isMobileViewport) {
            var tl = gsap.timeline();
            tl.from(contentRef.current, {
                opacity: 0,
                duration: 0.8,
                ease: Power2.easeInOut,
            }).from(contentRef.current, {
                y: 0,
                ease: Power2.easeInOut,
                duration: 1,
            }, "<");
        }
    }, []);
    return (_jsx("div", __assign({ className: "jobs__features__item__content flex w-full justify-start pl-8  lg:justify-end lg:pr-36 lg:pl-0" }, { children: _jsxs("div", __assign({ className: "jobs__features__content__wrapper flex w-full flex-col lg:block lg:w-2/3", ref: contentRef }, { children: [_jsx("img", { className: "jobs__features__content__image order-1 max-w-full mb-8 sm:mb-10", src: imageObject.src, alt: imageObject.alt }, void 0),
                _jsx("span", __assign({ className: "jobs__features__content__text__wrapper flex justify-start lg:justify-center" }, { children: _jsx("p", __assign({ className: "whitespace-pre-wrap break-words  text-left text-black lg:w-2/3 lg:text-sm" }, { children: mainContent.content }), void 0) }), void 0)] }), void 0) }), void 0));
};
export default ContentInformation;
